'use strict';

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IfEnabledDirectiveController=class IfEnabledDirectiveController{
static get $inject(){
return['userService'];
}

constructor(userService){
this.isEnabled=tryGet(userService,'currentUser.enabledFeatures').
then(features=>features.includes(this.feature)).
otherwise(!1);
}};let


IfEnabledDirective=class IfEnabledDirective extends BaseControllerBackedDirective{
get textBindings(){
return['feature'];
}

get template(){
return'<ng-transclude ng-if="::controller.isEnabled"/>';
}

get controller(){
return IfEnabledDirectiveController;
}

factory(){
let directive=super.factory();
directive.transclude=!0;
return directive;
}};


module.exports=IfEnabledDirective;
//# sourceMappingURL=ifEnabledDirective.js.map
